import React, { createContext, useContext, useEffect, useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import axios from 'axios';
import { BASE_URL, getCookie1, tmpToken } from '../Utlils';
import GlobalSkeleton from '../components/GlobalSkeleton';
import ErrorPage from '../components/ErrorPage';
import { getAuth } from '@mirats/mirats-auth';
import { addDiyUser, checkOrgExists } from '../Actions/OnboardingActions';
const CIS_BASE_URL = 'https://cis.app.miratsapiservices.com/v2/cis';
const COUNTRY_FIELDS = 'capital,name,alpha2Code,alpha3Code,emoji';

const GlobalContextProvider = createContext();
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export const useGlobalContext = () => {
  return useContext(GlobalContextProvider);
};

const GlobalContext = ({ children }) => {
  const [user, setUser] = useState({});
  const [userLoading, setUserLoading] = useState(true);
  const [globalError, setGlobalError] = useState({
    hasError: false,
    message: '',
  });

  const [globalLoader, setGlobalLoader] = useState({});

  //GET USER DATA:
  const getUser = async () => {
    try {
      setUserLoading(true);
      let gasUser = await getAuth();
      if (Object.keys(gasUser || {})?.length) {
        try {
          let diyUserRequest = await axios.get(
            `${BASE_URL}/users/one?gasId=${gasUser?.currentUser?._id}`,
          );
          let diyUser = diyUserRequest.data;
          if (Object.keys(diyUser || {})?.length) {
            setUser(diyUser);
            setUserLoading(false);
            if (diyUser?.accountStatus?.toLowerCase() !== 'active') {
              if (!window.location.href?.includes('/account-disabled')) {
                window.location.href = `${window.location.origin}/account-disabled`;
              }
              return;
            }
            let orgExists = await checkOrgExists(diyUser?.organizationId);
            if (!orgExists) {
              if (!window.location.href?.includes('/onboarding')) {
                window.location.href = `${window.location.origin}/onboarding`;
              }
            }
          } else {
            let newDiyUser = await addDiyUser(gasUser?.currentUser);
            if (!window.location.href?.includes('/onboarding')) {
              window.location.href = `${window.location.origin}/onboarding`;
            }
          }
        } catch (error) {
          console.log(error);
          // Check for CORS or network errors
          if (
            error?.message?.toLowerCase()?.includes('cors') ||
            error?.message?.toLowerCase()?.includes('network') ||
            error?.code === 'ERR_NETWORK' ||
            error?.response?.status === 0 ||
            !error?.response
          ) {
            setGlobalError({
              hasError: true,
              message:
                'Unable to connect to the server. This might be due to a network issue or CORS error. Please try again or contact support if the problem persists.',
            });
          }
          setUserLoading(false);
        }
      } else {
        setUserLoading(false);
      }
      // setUser({});
    } catch (error) {
      setUserLoading(false);
      console.log(error, error.message);
      // Check for CORS or network errors in outer catch
      if (
        error?.message?.toLowerCase()?.includes('cors') ||
        error?.message?.toLowerCase()?.includes('network') ||
        error?.code === 'ERR_NETWORK'
      ) {
        setGlobalError({
          hasError: true,
          message:
            'Unable to connect to the authentication service. Please try again or contact support.',
        });
      }
    }
  };
  const studyTypesData = [
    {
      label: 'Ad Effectiveness Research',
      value: 'Ad_Effectiveness_Research',
    },
    {
      label: 'Adhoc',
      value: 'adhoc',
    },
    {
      label: 'community-build',
      value: 'community_build',
    },
    {
      label: 'Face to Face',
      value: 'face_to_face',
    },
    {
      label: 'IHUT',
      value: 'IHUT',
    },
    {
      label: 'Internal Use',
      value: 'internal_use',
    },
    {
      label: 'Incidence Check',
      value: 'incidence_check',
    },
    {
      label: 'Qualitative Screening',
      value: 'qualitative_screening',
    },
    {
      label: 'Recontact',
      value: 'recontact',
    },
    {
      label: 'Recruit - Panel',
      value: 'recruit_panel',
    },
    {
      label: 'Tracking - Weekly',
      value: 'tracking_weekly',
    },
    {
      label: 'Tracking - Monthly',
      value: 'tracking_monthly',
    },
    {
      label: 'Tracking - Quaterly',
      value: 'tracking_quaterly',
    },
    {
      label: 'Tracking - Yearly',
      value: 'tracking_yearly',
    },
    {
      label: 'Tracking - Biyearly',
      value: 'tracking_biyearly',
    },
    {
      label: 'Wave Study',
      value: 'wave_study',
    },
  ];
  const allLanguages = [
    'Albanian',
    'Arabic',
    'Basque',
    'Belarusian',
    'Bengali',
    'Bosnian',
    'Bulgarian',
    'Catalan',
    'Croatian',
    'Czech',
    'Danish',
    'Dutch',
    'English',
    'Estonian',
    'Finnish',
    'French',
    'German',
    'Greek',
    'Hindi',
    'Hungarian',
    'Icelandic',
    'Irish',
    'Italian',
    'Japanese',
    'Latvian',
    'Lithuanian',
    'Maltese',
    'Mandarin Chinese',
    'Norwegian',
    'Portuguese',
    'Russian',
    'Spanish',
  ];

  const industryData = [
    {
      label: 'Agriculture',
      value: 'agriculture',
    },
    {
      label: 'Automotive & Mobility',
      value: 'automotive_and_mobility',
    },
    {
      label: 'Consumer Package Goods',
      value: 'consumer_package_goods',
    },
    {
      label: 'Construction',
      value: 'construction',
    },
    {
      label: 'Energy & Utilities',
      value: 'energy_and_utilities',
    },
    {
      label: 'Education',
      value: 'education',
    },
    {
      label: 'Fashion, Beauty & Luxury',
      value: 'fashion_beauty_and_luxury',
    },
    {
      label: 'Finance',
      value: 'finance',
    },
    {
      label: 'Government & Public Sector',
      value: 'government_and_public_sector',
    },
    {
      label: 'Health',
      value: 'health',
    },
    {
      label: 'Hospitality, Leisure & Travel',
      value: 'hospitality_leisure_and_travel',
    },
    {
      label: 'Media',
      value: 'media',
    },
    {
      label: 'Retail',
      value: 'retail',
    },
    {
      label: 'Sport & Leisure',
      value: 'sport_and_leisure',
    },
    {
      label: 'Technology & Telecoms',
      value: 'technology_and_telecoms',
    },
    {
      label: 'Others',
      value: 'others',
    },
  ];
  const statusOptions = [
    {
      label: 'Awarded',
      value: 'awarded',
    },
    {
      label: 'Archived',
      value: 'archived',
    },
    {
      label: 'Completed',
      value: 'completed',
    },
    {
      label: 'Live',
      value: 'live',
    },
    {
      label: 'Paused',
      value: 'paused',
    },
    {
      label: 'Billed',
      value: 'billed',
    },
  ];
  const taxIdTypes = [
    'Australian Business Number (AU ABN)',
    'Australian Taxation Office Reference Number',
    'Brazil CNPJ number',
    'Brazil CPF number',
    'Bulgaria Unified Identification Code',
    'Canada BN',
    'Canada GST/HST number',
    'Canadian PST number (British Columbia)',
    'Canadian PST number (Manitoba)',
    'Canadian PST number (Saskatchewan)',
    'Canadian QST number (Québec)',
    'Chilean TIN',
    'Egyptian Tax Identification Number',
    'EU VAT number',
    'European One Stop Shop VAT number for non-Union scheme',
    'Georgian VAT',
    'Hong Kong BR number',
    'Hungary tax number (adószám)',
    'Icelandic VAT',
    'Indonesian NPWP number',
    'Indian GST number',
    'Israel VAT',
    'Japanese Corporate Number (Hōjin Bangō)',
    "Japanese Registered Foreign Businesses' Registration Number (Tōroku Kokugai Jigyōsha no Tōroku Bangō)",
    'Japanese Tax Registration Number (Tōroku Bangō)',
    'Kenya Revenue Authority Personal Identification Number',
    'Liechtensteinian UID number',
    'Malaysian FRP number',
    'Malaysian ITN',
    'Malaysian SST number',
    'Mexican RFC number',
    'New Zealand GST number',
    'Norwegian VAT number',
    'Philippines Tax Identification Number',
    'Russian INN',
    'Russian KPP',
    'Saudi Arabia VAT',
    'Singaporean GST',
    'Singaporean UEN',
    'Slovenia tax number (davčna številka)',
    'South African VAT number',
    'South Korean BRN',
    'Spanish NIF number',
    'Switzerland VAT number',
    'Taiwanese VAT',
    'Thai VAT',
    'Turkish Tax Identification Number',
    'Ukrainian VAT',
    'United Arab Emirates TRN',
    'United Kingdom VAT number',
    'United States EIN',
    'Andorran NRT number',
    'Argentinian tax ID number',
    'Bolivian tax ID',
    'Chinese tax ID',
    'Colombian NIT number',
    'Costa Rican tax ID',
    'Dominican RCN number',
    'Ecuadorian RUC number',
    'Peruvian RUC number',
    'Romanian tax ID number',
    'El Salvadorian NIT number',
    'Serbian PIB number',
    'Uruguayan RUC number',
    'Venezuelan RIF number',
    'Vietnamese tax ID number',
  ];
  const currencies = [
    {
      label: 'US Dollar',
      value: 'USD',
      symbol: '$',
    },
    {
      label: 'Euro',
      value: 'EUR',
      symbol: '€',
    },
    {
      label: 'Japanese Yen',
      value: 'JPY',
      symbol: '¥',
    },
    {
      label: 'British Pound',
      value: 'GBP',
      symbol: '£',
    },
    {
      label: 'Australian Dollar',
      value: 'AUD',
      symbol: '$',
    },
    {
      label: 'Canadian Dollar',
      value: 'CAD',
      symbol: '$',
    },
    {
      label: 'Swiss Franc',
      value: 'CHF',
      symbol: 'CHF',
    },
    {
      label: 'Chinese Yuan Renminbi',
      value: 'CNY',
      symbol: '¥',
    },
    {
      label: 'Swedish Krona',
      value: 'SEK',
      symbol: 'kr',
    },
    {
      label: 'New Zealand Dollar',
      value: 'NZD',
      symbol: '$',
    },
    {
      label: 'Mexican Peso',
      value: 'MXN',
      symbol: '$',
    },
    {
      label: 'Singapore Dollar',
      value: 'SGD',
      symbol: '$',
    },
    {
      label: 'Hong Kong Dollar',
      value: 'HKD',
      symbol: '$',
    },
    {
      label: 'Norwegian Krone',
      value: 'NOK',
      symbol: 'kr',
    },
    {
      label: 'South Korean Won',
      value: 'KRW',
      symbol: '₩',
    },
    {
      label: 'Turkish Lira',
      value: 'TRY',
      symbol: '₺',
    },
    {
      label: 'Russian Ruble',
      value: 'RUB',
      symbol: '₽',
    },
    {
      label: 'Indian Rupee',
      value: 'INR',
      symbol: '₹',
    },
    {
      label: 'Brazilian Real',
      value: 'BRL',
      symbol: 'R$',
    },
    {
      label: 'South African Rand',
      value: 'ZAR',
      symbol: 'R',
    },
  ];
  const [myQuestion, setMyQuestion] = useState([]);
  const [questionLibrary, setQuestionLibrary] = useState([]);
  const [teamMembers, setTeamMembers] = useState([]);
  const [allSurveyGroup, setAllSurveyGroup] = useState([]);
  const [allInvoices, setAllInvoices] = useState([]);
  const [allInvoicesConfig, setAllInvoicesConfig] = useState({
    loading: true,
    error: false,
    noData: false,
  });
  const [organization, setOrganization] = useState({});
  const [countryData, setCountryData] = useState({
    isLoading: true,
    data: [],
    error: false,
  });
  const [allMonthsAndYear, setAllMonthsAndYear] = useState({
    months: [
      { name: 'January', value: 0 },
      { name: 'February', value: 1 },
      { name: 'March', value: 2 },
      { name: 'April', value: 3 },
      { name: 'May', value: 4 },
      { name: 'June', value: 5 },
      { name: 'July', value: 6 },
      { name: 'August', value: 7 },
      { name: 'September', value: 8 },
      { name: 'October', value: 9 },
      { name: 'November', value: 10 },
      { name: 'December', value: 11 },
    ],
    years: [],
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    msg: '',
    severity: '',
  });

  // get all invoices
  const getAllInvoices = async (id = user?.organizationId) => {
    try {
      setAllInvoicesConfig((prev) => ({ ...prev, loading: true }));
      let data = await axios.get(`${BASE_URL}/invoice?orgId=${id}`);
      setAllInvoices(data.data);
      if (data?.data?.length) {
        setAllInvoicesConfig((prev) => ({
          ...prev,
          loading: false,
          error: false,
        }));
      } else {
        setAllInvoicesConfig((prev) => ({
          ...prev,
          loading: false,
          noData: true,
        }));
      }
    } catch (error) {
      setAllInvoicesConfig((prev) => ({
        ...prev,
        loading: false,
        error: true,
      }));
      console.log('error in getting invoices');
    }
  };
  const getOrganization = async (id = user?.organizationId) => {
    try {
      let data = await (await axios.get(`${BASE_URL}/company/${id}`)).data;
      setOrganization(data);
      // if (
      //   !Object.keys(data || {})?.length &&
      //   window.location.pathname !== "/onboarding"
      // ) {
      //   window.location.href = `${window.location.origin}/onboarding`;
      // }
    } catch (error) {
      console.log('error in getting organization');
      setOrganization({});
    }
  };
  //GET TEAM MEMBERS:
  const getTeamMembers = async (e) => {
    try {
      setGlobalLoader((prev) => ({ teamMembers: true }));
      let data = await axios.get(
        `${BASE_URL}/users/team?orgId=${user?.organizationId}&id=${user?._id}`,
      );
      setTeamMembers(data.data);
      setGlobalLoader((prev) => ({ teamMembers: false }));
    } catch (error) {
      console.log('unable to get all team members');
    }
  };

  //GET MY QUESTIONS:
  const getMyQuestion = async (e) => {
    try {
      setGlobalLoader((prev) => ({ myQuestion: true }));
      let data = await axios.get(
        `${BASE_URL}/question?orgId=${user?.organizationId}`,
      );
      setMyQuestion(data.data);
      setGlobalLoader((prev) => ({ myQuestion: false }));
    } catch (error) {
      console.log('Unable to get all my questions');
    }
  };

  //GET ALL SURVEY GROUPS:
  const getAllSurveyGroup = async (e) => {
    try {
      setGlobalLoader((prev) => ({ allSurveyGroup: true }));
      let data = await axios.get(
        `${BASE_URL}/survey-group?orgId=${user?.organizationId}`,
      );
      setAllSurveyGroup(data.data);
      setGlobalLoader((prev) => ({ allSurveyGroup: false }));
    } catch (error) {
      console.log('Unable to get all survey groups');
    }
  };

  //GET QUESTION LIBRARY:
  const getQuestionLibrary = async (e) => {
    try {
      setGlobalLoader((prev) => ({ questionLibrary: true }));
      let data = await axios.get(`${BASE_URL}/questionLibrary`);
      setQuestionLibrary(data.data);
      setGlobalLoader((prev) => ({ questionLibrary: false }));
    } catch (error) {
      console.log('unable to get all question library');
    }
  };

  // months and year
  const getYears = async () => {
    let tempArr = [];
    for (let i = 5; i >= 0; i--) {
      tempArr.push(new Date().getFullYear() - i);
    }
    setAllMonthsAndYear((prev) => ({ ...prev, years: tempArr.reverse() }));
  };
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar((prev) => ({ ...prev, open: false }));
  };
  const handleCopy = (item, label) => {
    navigator.clipboard.writeText(item);
    setSnackbar({
      open: true,
      msg: `${label || 'Email'} Copied Successfully!`,
      severity: 'success',
    });
  };
  async function getCountries() {
    try {
      const countryResponse = await fetch(
        `${CIS_BASE_URL}/countries?all=true&fields=${COUNTRY_FIELDS}&sort=name&order=asc`,
        {
          method: 'GET',
          redirect: 'follow',
        },
      );
      const countryPayload = await countryResponse.json();
      const countryData = Array.isArray(countryPayload?.data)
        ? countryPayload.data
        : [];
      return countryData.map((country) => ({
        ...country,
        iso2: country?.alpha2Code || country?.iso2 || '',
        iso3: country?.alpha3Code || country?.iso3 || '',
      }));
    } catch (error) {
      console.log(error);
    }
  }
  async function getAllCountryStates(country) {
    try {
      const statesResponse = await fetch(
        `${CIS_BASE_URL}/countries/${country}/states?all=true&sort=name&order=asc`,
        {
          method: 'GET',
          redirect: 'follow',
        },
      );
      const statesPayload = await statesResponse.json();
      const statesData = Array.isArray(statesPayload?.data)
        ? statesPayload.data
        : [];
      return statesData;
    } catch (error) {
      console.log(error);
    }
  }
  async function getAllCities(country, state) {
    try {
      if (country && state) {
        const citiesResponse = await fetch(
          `${CIS_BASE_URL}/cities?all=true&country_code=${country}&state_code=${state}&sort=city_name&order=asc`,
          {
            method: 'GET',
            redirect: 'follow',
          },
        );
        const citiesPayload = await citiesResponse.json();
        const citiesData = Array.isArray(citiesPayload?.data)
          ? citiesPayload.data
          : [];
        return citiesData;
      } else {
        return [];
      }
    } catch (error) {
      console.log(error);
    }
  }
  async function fetchCountries() {
    try {
      setCountryData({ isLoading: true });
      let data = await getCountries();
      setCountryData({ isLoading: false, data: data, error: false });
    } catch (error) {
      setCountryData({ isLoading: false, data: [], error: true });
    }
  }

  useEffect(() => {
    if (Object.keys(user)?.length !== 0) {
      getOrganization(user?.organizationId);
      getTeamMembers();
      getAllInvoices();
      getQuestionLibrary();
      getYears();
      getAllSurveyGroup();
      getMyQuestion();
    } else {
      getUser();
      fetchCountries();
    }
  }, [Object?.keys(user || {})?.length]);
  // console.log(user);
  // console.log(organization);
  const value = {
    user,
    getUser,
    setUser,
    setSnackbar,
    myQuestion,
    getMyQuestion,
    teamMembers,
    allSurveyGroup,
    questionLibrary,
    getTeamMembers,
    getAllSurveyGroup,
    globalLoader,
    setGlobalLoader,
    allMonthsAndYear,
    allInvoices,
    studyTypesData,
    industryData,
    statusOptions,
    allLanguages,
    taxIdTypes,
    currencies,
    organization,
    setOrganization,
    getOrganization,
    getCountries,
    getAllCountryStates,
    getAllCities,
    countryData,
    allInvoicesConfig,
    handleCopy,
  };

  // Handle retry from error page
  const handleErrorRetry = () => {
    setGlobalError({ hasError: false, message: '' });
    setUserLoading(true);
    getUser();
  };

  return (
    <GlobalContextProvider.Provider value={value}>
      {globalError.hasError ? (
        <ErrorPage
          onRetry={handleErrorRetry}
          errorMessage={globalError.message}
        />
      ) : userLoading ? (
        <GlobalSkeleton />
      ) : (
        children
      )}

      <Snackbar
        open={snackbar?.open}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={snackbar?.severity}
          sx={{ width: '100%' }}
        >
          {snackbar?.msg}
        </Alert>
      </Snackbar>
    </GlobalContextProvider.Provider>
  );
};

export default GlobalContext;
